import React, { useState, useEffect } from 'react';
import { X } from 'lucide-react';

export default function MobileNotification() {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    // Check if device is mobile
    const isMobile = window.innerWidth <= 768;
    setIsVisible(isMobile);
  }, []);

  if (!isVisible) return null;

  return (
    <div className="fixed bottom-0 left-0 right-0 bg-indigo-600 text-white p-4 z-50">
      <div className="max-w-[1440px] mx-auto px-4 flex items-center justify-between">
        <p className="text-sm pr-8">
          The app is currently designed for optimal desktop performance, and we are working diligently to deliver a smooth, fully responsive experience on mobile devices.
        </p>
        <button 
          onClick={() => setIsVisible(false)}
          className="flex-shrink-0 text-white hover:text-white/80"
        >
          <X className="h-5 w-5" />
        </button>
      </div>
    </div>
  );
}